import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, onMounted, onUnmounted } from 'vue';

const DEFAULT_MESSAGE =
	'A network interruption was detected. Progress updates may have stopped. ' +
	'Please refresh the page to continue.';


export default /*@__PURE__*/_defineComponent({
  __name: 'NetworkStatusBanner',
  props: {
    message: { type: String, required: false, default: DEFAULT_MESSAGE }
  },
  setup(__props: any, { expose: __expose }) {
  __expose();

const props = __props;

const isVisible = ref(false);
const wentOffline = ref(false);

const displayMessage = computed(() => props.message);

const reload = () => {
	window.location.reload();
};

const trigger = () => {
	isVisible.value = true;
};

const handleOffline = () => {
	wentOffline.value = true;
	trigger();
};

const handleOnline = () => {
	if (wentOffline.value) {
		// Network interface changed — SignalR socket is dead even though
		// connectivity is restored. A full reload is required.
		trigger();
	}
};

onMounted(() => {
	window.addEventListener('offline', handleOffline);
	window.addEventListener('online', handleOnline);
});

onUnmounted(() => {
	window.removeEventListener('offline', handleOffline);
	window.removeEventListener('online', handleOnline);
});

const __returned__ = { DEFAULT_MESSAGE, props, isVisible, wentOffline, displayMessage, reload, trigger, handleOffline, handleOnline }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})